import { css } from 'linaria';
export const customClass = "c1mmbh1h";
export const container = "cuz86j3";
export const buttonContainer = "b1bwb04x";
export const heading = "ht5qsc";
export const optionsContainer = "o143ueqp";
export const option = "o1k32lbd";
export const scale = "s1h3ebm2";

require("../../../../.linaria-cache/components/v2/dialogs/ImpactQuestions/styles.linaria.module.css");